import React from 'react';
import brandBanner from "./images/logo.png"
import './styles/dashboard.css';
import firebase, { auth, provider } from './firebase'
import { Link } from "react-router-dom";
import calligraphy from "./images/calligraphy.png"
import pottery from "./images/pottery.png"
import karate from "./images/karate.png"
import origami from "./images/origami.png"

import person from "./images/personm.png"
import  Pranshu from "./images/Pranshu Gupta.jpg"
import  Shrija from "./images/Shrija Mishra.jpg"

export default class Discover extends React.Component {
    constructor() {
        super();
        this.state = {
            skill: '',
            // username: '',
            items: [],
            // user: null
        }
        this.search = this.search.bind(this);
    }
    search(e) {
        e.preventDefault();
        this.setState({
            [e.target.name]: e.target.value
        });
        const itemref = firebase.database().ref('masters');
        itemref.on('value', (snapshot) => {
            let items = snapshot.val();
            let newState = [];
            for (let item in items) {
                newState.push({
                    id: item,
                    username: items[item].username,
                    email: items[item].email,
                    skills: {
                        name: items[item].skills.name,
                        level: items[item].skills.level
                    }

                });
            }

            this.setState({
                items: newState
            });
        })
    }

    render() {
        return (
            <div className="row-fluid">
                <br></br>
                <img src={brandBanner} className="img-fluid" style={{ height: "64px" }}></img>
                <br /><br />
                <p>
                    On SkillEd, you can make new friends and learn new skills along the way. You can also mentor others in things you are good at. With SkillEd, we bring the personal touch to skill sharing.
                </p>
                <br />
                <h3>Discover</h3>
                <div className="form-group has-search">
                    <span className="fa fa-search form-control-feedback"></span>
                    <input type="text" className="form-control" placeholder="Search" name="skill" onChange={this.search} value={this.state.skill} />
                </div>
                <br />
                {this.state.items.map((item) => {
                    return (
                        <div>
                            {item.skills.name.toLowerCase() == this.state.skill.toLowerCase() ?
                                <div>
                                    <div className="row">
                                        {item.username=="Pranshu Gupta"?
                                        <div className="col-sm-2" style={{ margin: 0, padding: 0 }}>
                                        <img alt="person" src={Pranshu} className="img-fluid rounded-circle" id="profilePicSmall"></img>
                                    </div>
                                    :
                                    <div className="col-sm-2" style={{ margin: 0, padding: 0 }}>
                                            <img alt="person" src={Shrija} className="img-fluid rounded-circle" id="profilePicSmall"></img>
                                        </div>
                                        }
                                        
                                        <div className="col-sm-5">
                                            <Link style={{ textDecoration: 'none' }} to="/publicProfile/" props={item.username} >
                                                <h3>{item.username}</h3>
                                            </Link>
                                            <span class="fa fa-star checked"></span>
                                            <span class="fa fa-star checked"></span>
                                            <span class="fa fa-star checked"></span>
                                            <span class="fa fa-star checked"></span>
                                            <span class="fa fa-star"></span>
                                            <br></br>
                                            <h6>Atlanta, GA, United States</h6>
                                        </div>
                                        <div className="col-sm-5" style={{ textAlign: "right" }}>
                                            <br></br>
                                            <h3>{parseInt(5000*Math.random())}</h3>
                                            <button className="btn btn-dark">Schedule and Meet</button>
                                        </div>
                                    </div>
                                    <hr></hr>
                                </div>
                                :
                                <div></div>
                            }
                        </div>
                    )
                })}
                <br></br>
                <h3>Interests</h3>
                <div className="row" id="interests" style={{ textAlign: "left" }}>
                    <div className="col"><img src={pottery} className="img-fluid"></img><br /><br /><h3>Pottery</h3> with John Joshua</div>
                    <div className="col"><img src={calligraphy} className="img-fluid"></img><br /><br /><h3>Calligraphy</h3>with Sameer Dustin</div>
                    <div className="col"><img src={karate} className="img-fluid"></img><br /><br /><h3>Karate</h3>with Radhika Apte</div>
                    <div className="col"><img src={origami} className="img-fluid"></img><br /><br /><h3>Origami</h3>with Istanio Humao</div>
                </div>
                <br></br><br></br><br></br><br></br>
            </div>
        );
    }
}